import React from 'react'
import { Link } from 'gatsby'
import { css, useTheme } from '@emotion/react'
import Container from 'components/container.js'
import Socials from 'components/socials'
import logo from 'images/numark-logo-white.svg'
import accountIcon from 'images/account.svg'
import inmusicLogoBlack from 'images/inmusic-logo-black.svg'

const column = theme => css({
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    fontSize: 14,
    '& :first-child': {
        fontSize: 'inherit',
        fontWeight: 600,
    }
})

export default function Footer() {
    const theme = useTheme()

    return <footer>
        <Container>
            <div css={{
                paddingInline: 120,
                paddingBlock: 80,
                [theme.queries.lg]: { paddingInline: 80 },
                [theme.queries.md]: { padding: 40 },
                [theme.queries.sm]: { paddingInline: 16 },
            }}>
                <div
                    className='d-flex justify-content-between'
                    style={{ gap: 20 }}
                    css={{
                        alignItems: 'center',
                        '@media(max-width: 375px)': {
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                        }
                    }}
                >
                    <a href='/'><img src={logo} alt='' height={22} /></a>
                    <Socials />
                </div>

                <div css={{
                    display: 'grid',
                    gap: 20,
                    marginTop: 80,
                    gridTemplateColumns: 'repeat(4, 1fr)',

                    [theme.queries.md]: {
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        gap: 40,
                        marginTop: 40,
                    },
                }}>
                    <div css={column}>
                        <p>Products</p>
                        <a href='/product_category/controllers'>Controllers</a>
                        <a href='/product_category/mixers'>Mixers</a>
                        <a href='/product_category/turntables'>Turntables</a>
                        <a href='/product_category/accessories'>Accessories</a>
                    </div>

                    <div css={column}>
                        <p>Company</p>
                        <a href='/company/about'>About Us</a>
                        <a href='/news/cat/press_releases'>Press Releases</a>
                        <a href='/dealers'>Dealers</a>
                    </div>

                    <div css={column}>
                        <p>Support</p>
                        <a href='https://profile.inmusicbrands.com' target='_blank' rel='noreferrer noopener'>Product Registration</a>
                        <a href='https://support.numark.com/' target='_blank' rel='noreferrer noopener'>Contacts Us</a>
                        <a href='/repairs'>Repairs</a>
                    </div>
                    
                    <div css={column}>
                        <p>Account</p>
                        <a
                            href='https://profile.inmusicbrands.com'
                            target='_blank'
                            rel='noreferrer noopener'
                            className='d-flex align-items-center text-decoration-none'
                            css={{ '&:hover':{ background: 'hsl(0 0 10%)' }}}
                            style={{
                                gap: 8,
                                padding: 12,
                                border: `1px solid ${theme.colors.white}`,
                                transition: 'background .25s ease',
                            }}
                        >
                            <img src={accountIcon} alt='' height={16} width={16} />
                            Login
                        </a>
                    </div>
                </div>
            </div>
        </Container>

        <Container fluid css={{ backgroundColor: '#C2C2C2' }}>
            <Container>
                <div className='d-flex flex-column' css={{
                    gap: 48,
                    paddingBlock: 40,
                    paddingInline: 120,
                    [theme.queries.lg]: { paddingInline: 80 },
                    [theme.queries.md]: { padding: 40 },
                    [theme.queries.sm]: { paddingInline: 16, gap: 20 },
                }}>
                    {/* INMUSIC LOGO + LINE */}
                    <div className='d-flex align-items-center' css={{ gap: 24 }}>
                        <a href='https://inmusicbrands.com' target="_blank" rel="noreferrer">
                            <img src={inmusicLogoBlack} alt='inmusic logo black' height={32} />
                        </a>
                        <div style={{
                            height: 1,
                            flexGrow: 1,
                            backgroundColor: 'black',
                            transform: 'scaleY(0.5)', // half pixel
                        }} />
                    </div>

                    {/* COPYRIGHT | LINKS | PART OF... */}
                    <div
                        className='d-flex flex-lg-row flex-column justify-content-between'
                        style={{
                            color: theme.colors.black,
                            gap: 20,
                        }}
                    >
                        <div
                            className='d-flex flex-wrap'
                            style={{
                                fontSize: 12,
                                alignItems: 'baseline',
                                gap: 4,
                            }}
                        >
                            <p style={{ fontSize: 'inherit' }}>
                                © {new Date().getFullYear()} inMusic, Inc. All Rights Reserved.
                            </p>
    
                            <div style={{ color: theme.colors.black }}>
                                <a href='/dealers'>
                                    Dealers
                                </a>
                                &nbsp;|&nbsp;
                                <a href='https://support.numark.com/' target="_blank" rel="noreferrer noopener">
                                    Support
                                </a>
                                &nbsp;|&nbsp;
                                <a href='https://inmusicbrands.pinpointhq.com/' target="_blank" rel="noreferrer noopener">
                                    Careers
                                </a>
                                &nbsp;|&nbsp;
                                <a href='/company/privacy_policy'>
                                    Privacy
                                </a>
                                &nbsp;|&nbsp;
                                <a href='/company/terms-of-use'>
                                    Terms of Use
                                </a>
                                &nbsp;|&nbsp;
                                <div id="teconsent" className='d-inline-block' />
                            </div>
                        </div>

                        <p style={{
                            fontSize: 14,
                            fontWeight: 700,
                        }}>
                            Part of the inMusic family of brands
                        </p>
                    </div>
                </div>
            </Container>
        </Container>
    </footer>
}
